// @flow
import SubsPage from './SubsPage';

export default SubsPage;
